import { post } from "./lib";

import readRoute from "../api/settings/narrative-prefix/read.route";
import upsertRoute from "../api/settings/narrative-prefix/upsert.route";
import { NarrativePrefixType } from "pages/api/settings/narrative-prefix/types";
import deleteRoute from "pages/api/settings/narrative-prefix/delete.route";

// Default keys as const
export const DefaultPrefixKeys = {
  NARRATIVE: "narrative",
  AGENT: "agent",
} as const;

// Type that allows any string but includes the default keys
export type PrefixGlobalKey = (typeof DefaultPrefixKeys)[keyof typeof DefaultPrefixKeys] | string;

export async function upsertNarrativePrefix({
  id,
  prefix,
  name,
  global_key,
}: Omit<NarrativePrefixType, "created_at" | "updated_at">) {
  return post<typeof upsertRoute>(`/api/settings/narrative-prefix/upsert`, {
    id,
    prefix,
    name,
    global_key,
  });
}

export async function deleteNarrativePrefix(id: string) {
  return post<typeof deleteRoute>(`/api/settings/narrative-prefix/delete`, {
    id,
  });
}

export const readNarrativePrefix = (globalKey?: PrefixGlobalKey) =>
  post<typeof readRoute>(`/api/settings/narrative-prefix/read`, {
    global_key: globalKey,
  });
